import { Dictionary } from 'app/services/dict.service';

export const getAutofilledStreet = (
  dictionary: Dictionary,
  city: string
): string | undefined => {
  if (!dictionary.length) {
    return city;
  }

  if (dictionary.length === 1) {
    return dictionary[0].value;
  }

  return undefined;
};
